import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/workers.css";

const WorkersMaster = () => {
  const [workerName, setWorkerName] = useState("");
  const [workers, setWorkers] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const fetchWorkers = async () => {
    const { data } = await supabase
      .from("WORKERS")
      .select("*")
      .order("id", { ascending: true });
    setWorkers(data);
  };

  useEffect(() => {
    fetchWorkers();
  }, []);

  const handleSave = async () => {
    if (!workerName.trim()) return alert("Enter worker name");

    if (editingId) {
      await supabase
        .from("WORKERS")
        .update({ worker_name: workerName })
        .eq("id", editingId);
      setEditingId(null);
    } else {
      await supabase.from("WORKERS").insert([{ worker_name: workerName }]);
    }

    setWorkerName("");
    fetchWorkers();
  };

  const handleEdit = (worker) => {
    setWorkerName(worker.worker_name);
    setEditingId(worker.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this worker?")) return;
    await supabase.from("WORKERS").delete().eq("id", id);
    fetchWorkers();
  };

  return (
    <div className="main-content">
      <div className="workers-container">
        <h2 className="title">Workers Master</h2>

        {/* Form */}
        <div className="row-line">
          <label htmlFor="worker-name">Worker Name</label>
          <input
            id="worker-name"
            type="text"
            value={workerName}
            onChange={(e) => setWorkerName(e.target.value)}
            placeholder="Enter worker name"
          />
          <button className="btn-save" onClick={handleSave}>
            {editingId ? "Update" : "Save"}
          </button>
        </div>

        <div className="divider"></div>

        {/* Table */}
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Worker Name</th>
                <th className="th-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {workers.map((w) => (
                <tr key={w.id}>
                  <td>{w.worker_name}</td>
                  <td className="td-center">
                    <button className="btn-edit" onClick={() => handleEdit(w)}>
                      Edit
                    </button>
                    <button
                      className="btn-delete"
                      onClick={() => handleDelete(w.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {workers.length === 0 && (
                <tr>
                  <td colSpan="2" className="no-data">
                    No workers found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WorkersMaster;
